import { Link } from 'gatsby';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const TemplateContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
  padding: 80px 24px 150px;
  max-width: 960px !important; // used to fully override Layout max-width
  width: 100%;
`

export const TemplateEncyclopediaPageTitle = styled.div`
  display: grid;
  justify-self: center;
  margin-bottom: 5rem;

  h1 {
    margin-bottom: 1rem;
  }
`;

export const TemplateTitle = styled.div`
  display: flex;
  margin: 0px auto;
  max-width: 712px;
  width: 100%;
  margin-bottom: 2rem;

  @media all and (max-width: ${layout.sm}) {
    justify-content: center;
  }
`

export const TemplateTitleGoBackButton = styled(Link)`
  align-self: center;
  justify-self: center;
  cursor: pointer;
  margin-right: 2rem;
  transition: transform 0.2s ease-in-out;
  width: 29px;
  height: 29px;

  @media all and (max-width: ${layout.sm}) {
    width: 16px;
    height: 16px;
    margin-right: 0.8rem;
  }

  &:hover {
    transform: translateX(-5px);
  }
`

export const TemplateContent = styled.div`
  max-width: 712px;
  margin: 0px auto;

  p.center {
    text-align: center;
    margin-bottom: 2rem;
  }

  p {
    font-size: 1.1rem;
    font-weight: 300;
    line-height: 1.7;
    margin: .5em 0em;
    margin: 0 0 2rem;
    -webkit-font-smoothing: antialiased;
  }

  a {
    text-decoration: none;
    color: ${palette.snowFlower};
    font-weight: 500;

    &.button{
      background: ${palette.snowFlower};
      color: ${palette.white};
      min-width: 256px;
      padding: 11px 20px 13px;
      border-radius: 4px;
      justify-self: center;
      position: relative;
      top: 0.5rem;
    }
  }

  h2 {
    font-size: 2.5em;
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    font-family: 'Walsheim';
  }

  h3 {
    font-size: 2em;
    line-height: 1.4;
    margin: 0;
    padding-top: 24px;
    font-family: 'Walsheim';
  }

  h4 {
    font-size: 1.4rem;
    line-height: 1.2;
    text-align: center;
    font-family: 'Walsheim';
    font-weight: 600;
    margin: 0 0 40px;

    @media all and (max-width: ${layout.sm}) {
      font-size: 1.1rem;
    }
  }

  ul {
    margin-bottom: 0px;
    margin-left: 30px;
    list-style-type: disc;

    li {
      margin-bottom: 20px;
      font-size: 1.1em;
      font-weight: 300;
      -webkit-font-smoothing: antialiased;
    }
  }

  ol {
    text-align: left;
    margin: 0 0 1.8rem;

    li {
      font-size: 1.1rem;
      display: list-item;
      -webkit-font-smoothing: antialiased;
      font-weight: 300;
      line-height: 1.4;
      margin-bottom: 1.8rem;
    }
  }
`
